import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {_libs} from "../../../utils/_libs.js";

export const otherIndustriesBlock = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.other-industries', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const sliderImages = section.querySelector('.other-industries__images-swiper');
    const sliderText = section.querySelector('.other-industries__text-swiper');
    const sliderTabs = section.querySelector('.other-industries__tabs')
    const tabs = section.querySelectorAll('.other-industries__tabs-item')

    let swiperTabs = null;
    let swiperImages = null;
    let swiperText = null;
    const autoplayDelay = 10000;

    const createSwiper = () => {
        if (swiperTabs !== null) {
            swiperTabs.destroy(true, true);
            swiperTabs = null;
        }

        if (!swiperTabs && !_state.isDesktop) {
            swiperTabs = _libs._swiper(sliderTabs, {
                slidesPerView: 'auto',
                freeMode: true,
                // centeredSlides: true,
                spaceBetween: 8,
                disableOnInteraction: false,
            });
        }

        if (swiperImages !== null) {
            swiperImages.destroy(true, true);
            swiperImages = null;
        }

        if (!swiperImages) {
            swiperImages = _libs._swiper(sliderImages, {
                slidesPerView: 1.3,
                speed: 1000,
                centeredSlides: true,
                spaceBetween: 16,
                keyboard: {
                    enabled: true,
                },

                // autoHeight: true,

                autoplay: {
                    enabled: true,
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },

                breakpoints: {
                    1025: {
                        direction: 'vertical',
                        slidesPerView: 1,
                        allowTouchMove: false,
                        spaceBetween: 50,
                    },
                },
                on: {
                    init: function (s) {
                        tabs.forEach(t => t.classList.remove('active'));
                        const activeTab = tabs[s.activeIndex];
                        activeTab.classList.add('active');
                    },
                },
            });
            swiperImages.on('slideChange', function (s) {
                const activeIndex = s.activeIndex;

                // set custom classes for prev,next slides
                sliderImages.querySelectorAll('.swiper-slide').forEach((slide, index) => {
                    // Видаляємо попередні класи, щоб уникнути конфліктів
                    slide.classList.remove('custom-slide-prev', 'custom-slide-next');

                    const counterValue = index - activeIndex;
                    slide.style.setProperty('--image-number', counterValue);

                    // Додаємо класи для всіх попередніх слайдів
                    if (index < activeIndex) {
                        slide.classList.add('custom-slide-prev');
                    }
                    // Додаємо класи для всіх наступних слайдів
                    else if (index > activeIndex) {
                        slide.classList.add('custom-slide-next');
                    }
                });

                // change active tab
                tabs.forEach(t => t.classList.remove('active'));
                const activeTab = tabs[activeIndex];
                activeTab.classList.add('active');
            });
            swiperImages.on('autoplayTimeLeft', (s, time, progress) => {
                const active = s.activeIndex;
                const percent = (1 - progress) * 100;

                tabs.forEach((tab, i) => {
                    tab.style.setProperty('--progress', i === active ? `${percent}%` : '0%');
                });
            });
        }

        if (swiperText !== null) {
            swiperText.destroy(true, true);
            swiperText = null;
        }

        if (!swiperText) {
            swiperText = _libs._swiper(sliderText, {
                slidesPerView: 1,
                spaceBetween: 16,
                effect: "fade",
                allowTouchMove: false,
                fadeEffect: {
                    crossFade: true,
                },
                keyboard: {
                    enabled: false,
                },
                autoplay: {
                    enabled: false,
                },
                breakpoints: {
                    1025: {
                       autoHeight: true,
                    },
                },
            });
        }
        if (swiperImages && (swiperText || swiperTabs)) {
            const controls = [];

            if (swiperText) controls.push(swiperText);
            if (swiperTabs) controls.push(swiperTabs);

            swiperImages.controller.control = controls;
        }
    }

    const tabsHandler = ()=> {
        tabs?.forEach((tab,index)=> {
            tab.addEventListener('click',()=> {
                tabs?.forEach((tab)=> {
                    tab.classList.remove('active')
                })
                tab.classList.add('active')
                swiperImages.slideTo(index)
            })
        })
    }

    createSwiper();
    tabsHandler();

    const rebuildFunc = () => {
        createSwiper();
        tabsHandler();
    }
    _utils.rebuildComponentsOnResize(rebuildFunc);
}